<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="12" xl="10">
        <CRow>
          <CCol xs="12" sm="4" md="3" lg="3" xl="2">
            <div class="form-group">
              <label for="datepicker">Từ ngày - đến ngày</label>
              <DatePicker id="datepicker" locale="vi" v-model="dateRange"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                          :popover="{ visibility: 'click' }" is-range class="datepicker">
                <template v-slot="{ inputValue, inputEvents }">
                  <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                         class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly/>
                </template>
              </DatePicker>
            </div>
          </CCol>
          <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
            </BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol> -->
          <CCol xs="12" sm="4" md="4" lg="4" xl="2">
            <BaseSelect :options="historyType.options" :data="historyType.data" ref="historyType"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="4" md="4" lg="4" xl="2">
            <BaseSelect :options="deviceInput.options" :data="deviceInput.data" ref="deviceInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="4" md="4" lg="4" xl="2">
            <BaseInput :options="titleFileInput.options" :data="titleFileInput.data"/>
          </CCol>
        </CRow>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="2">
        <CRow>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
                         class="btn-action-primary" @click="loadDataMainTable(true)">
                  <i class="fa fa-refresh"></i>&nbsp; Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                   ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #code="{ item }">
            <td>
              <span :key="item.code" class="badge badge-light" v-c-tooltip.hover="item.description">{{
                  item.code
                }}</span>
            </td>
          </template>
          <template #fileTitle="{ item }">
            <td style="font-weight: bold; cursor: pointer">
              <span v-c-tooltip.hover="'Ấn để nghe'" @click="previewFile(item.fileTitle, item.fileUrl)">{{
                  item.fileTitle
                }}</span>
            </td>
          </template>
          <template #createDate="{ item }">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #locationName="{ item }">
            <td>
              <span class="badge badge-light">{{ item.locationName }}</span>
            </td>
          </template>
          <template #updateDate="{ item }">
            <td>
              <span v-if="item.status != 0">{{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}</span>
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <span class="badge badge-warning" v-if="item.status == 0">Đang phát</span>
              <span class="badge badge-success" v-else-if="item.status == 1">Đã phát</span>
              <span class="badge badge-danger" v-else-if="item.status == 2">Phát lỗi</span>
            </td>
          </template>
          <template #action="{ item }">
            <td>
              <CButton color="info" variant="outline"
                       v-c-tooltip.hover="{ placement: 'bottom', content: 'Thông tin lịch phát' }" square size="sm"
                       @click="findOne(item.id)">
                <i class="fa fa-eye"/>
              </CButton>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <BaseModal title='Thông tin lịch phát' :show.sync="detailModel.isShowModal" :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <CCol xs="12" sm="12" lg="12" xl="12" class="form-group">
          <CCol xs="12" sm="12" lg="12" xl="12">
            <label><span style="font-weight: bold">Người tạo lịch: </span>{{ detailModel.data.createUserName }}</label>
          </CCol>
          <CCol xs="12" sm="12" lg="12" xl="12">
            <label><span style="font-weight: bold">Địa bàn tạo: </span>{{ detailModel.data.locationName }}</label>
          </CCol>
          <CCol xs="12" sm="12" lg="12" xl="12">
            <label><span style="font-weight: bold">Ngày tạo: </span>{{
                $helper.formatDateDDMMYYYYHHMM(detailModel.data.createDate)
              }}</label>
          </CCol>
        </CCol>

      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="detailModel.isShowModal = false"><i
            class="fa fa-close"></i> Đóng
          </button>&nbsp;
          <button type="button" class="btn btn-primary" v-if="detailModel.data.mode != 3"
                  @click="$router.push(`/schedule-management/${detailModel.data.scheduleId}/managed-shedule-detail.html`)">
            <i class="fa fa-eye"></i> Xem lịch
          </button>
        </div>
      </template>
    </BaseModal>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>

    <BaseFormPreview v-if="previewModel.isShowModal"
                     :title="previewModel.title"
                     :url="previewModel.url"
                     @close-modal="previewModel.isShowModal = false"></BaseFormPreview>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import {HistoryTypeList} from '../../constant';
import BaseModal from "@/views/base/BaseModal";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "HistoryList",
  components: {
    BaseFormPreview,
    BaseModal,
    BaseFormLoading,
    BaseTable,
    BaseInput,
    BaseSelect,
    DatePicker,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    return {
      loading: {value: false},
      loadingPreview: {value: false},
      dateRange: {
        start: that.$helper.subtractNowDate(3),
        end: new Date()
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: ''
      },
      detailModel: {
        isShowModal: false,
        data: {}
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad:  true,
          disabled:  true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      historyType: {
        options: {
          filter: false,
          label: "Trạng thái",
        },
        data: {
          name: "status",
          items: HistoryTypeList,
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      titleFileInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: 'Tiêu đề bản tin'
        },
        data: {
          name: "titleFile",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      deviceInput: {
        options: {
          filter: true,
          label: "Thiết bị",
          selectAllText: "Tất cả thiết bị",
          'keyField': 'value',
          'valueField': 'text'
        },
        data: {
          name: "deviceId",
          model: '',
          items: [],
          source: {
            url: '/devices/find-all',
            dataSubmit: function () {
              return {}
            },
            isJsonContentType: false,
            response: function (dataResponse) {
              that.deviceInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Thời gian bắt đầu"},
            {key: "updateDate", label: "Thời gian kết thúc"},
            {key: "fileTitle", label: "Nội dung phát"},
            {key: "status", label: "Trạng thái"},
            {key: "code", label: "Mã thiết bị"},
            {key: "locationName", label: "Địa bàn thiết bị"},
            // {key: "createUserNameSchedule", label: "Người tạo"},
            {key: "action", label: "Thao tác"},
          ],
          slots: [
            "index",
            "createDate",
            "updateDate",
            "fileTitle",
            "status",
            "locationName",
            "code",
            "action"
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false,
          sorter: true,
          columnFilter: false,
          pageSize: 15,
          itemsPerPageSelect: {label: ' ', values: [15, 20, 50], external: true},
          tableFilter: {label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true},
        },
        dataSource: {
          url: "/history/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
      hlsPreview: '',
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    findOne: function (id) {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        url: "/history/find-by-id",
        dataSubmit: function () {
          return {id: id}
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            let data = response.data.data;
            that.detailModel.data = data;
            that.loading.value = false;
            that.detailModel.isShowModal = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    previewFile(title, url) {
      this.previewModel.url = url;
      this.previewModel.title = title;
      this.previewModel.isShowModal = true;
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
